const local = 'http://localhost:8080/api/';
const remoto = 'https://seira.aesa.logap.com.br/api/';

export const environment = {
	production: false,
	API_URL: remoto,
};
